exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".shipping-time{font-weight:800}.card{padding:2em}.model-img-cont{margin:0 auto}.card-container{display:flex;flex-grow:1;justify-content:space-between}.p-card .p-card-content{padding:0!important;text-align:center}.clear:after{clear:both;content:\"\";display:table}.model-img-cont img{max-width:90%}.p-button{background:#007ad9;border:1px solid #007ad9}.p-datatable .p-sortable-column.p-highlight{background:#969696;color:#fff}.letter-link-cont{padding:1.7em}.letter-link{padding:.8em;font-size:18pt}.supplier-card-list-cont{padding-top:1em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0301527c","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/view/pages/SuppliersList.vue
// module id = 461
// module chunks = 0